import { MetricsRequest } from "../../models/metrics"
import { instanceConfig } from "../config"
import axios from "axios"

const apiInstance = axios.create({
    ...instanceConfig,
    baseURL: "/"
})

const fullPath = "/frontend-system-metrics"

const metricsController = {
    sendMetrics(metrics: MetricsRequest[]): Promise<void> {
        if (!metrics || !metrics.length) {
            return Promise.resolve()
        }

        if (navigator.sendBeacon) {
            navigator.sendBeacon(fullPath, new Blob([JSON.stringify(metrics)], { type: "application/json" }))
            return Promise.resolve()
        }

        return apiInstance.post(fullPath, metrics)
    }
}

export default metricsController
